export type StepVisualState = "current" | "reached" | "upcoming" | "locked";

export function getStepVisualState(params: {
    index: number;
    currentIndex: number;
    furthestIndex: number;
    maxReachableIndex: number;
}): StepVisualState {
    const { index, currentIndex, furthestIndex, maxReachableIndex } = params;

    if (index > maxReachableIndex) {
        return "locked";
    }
    if (index === currentIndex) {
        return "current";
    }
    if (index <= furthestIndex) {
        return "reached";
    }
    return "upcoming";
}

export function isStepClickable(state: StepVisualState): boolean {
    return state === "reached";
}

/** Connector before step `segmentEndIndex` is filled when that step has been reached. */
export function isConnectorFilled(segmentEndIndex: number, furthestIndex: number): boolean {
    return furthestIndex >= segmentEndIndex;
}
